/* eslint-disable no-console */
import React, { useState, useEffect } from 'react';
import Draggable from 'react-draggable';
import { Modal, Box, Grid, Tooltip, Radio, RadioGroup, FormControlLabel, FormControl, Button } from '@mui/material';

import { closeIconBlack, calculator_icon } from '../../shared/assets/images';
import './ro.scss';

function ElementAgeCalculator(props) {
  const { visibleEAC, handleCloseEAC, translateObject } = props;
  const [fractionValue, setFractionValue] = useState(0);
  const [intervalValue, setIntervalValue] = useState(0);
  const [ageValue, setAgeValue] = useState(0);
  const [fractionDisabled, setFractionDisabled] = useState(false);
  const [intervalDisabled, setIntervalDisabled] = useState(false);
  const [ageDisabled, setAgeDisabled] = useState(true);
  const [value, setValue] = React.useState('ageValue');

  const handleChange = (event) => {
    setValue(event.target.value);
    if (event.target.value === 'fractionValue') {
      setFractionDisabled(true);
      setIntervalDisabled(false);
      setAgeDisabled(false);
    } else if (event.target.value === 'intervalValue') {
      setFractionDisabled(false);
      setIntervalDisabled(true);
      setAgeDisabled(false);
    } else if (event.target.value === 'ageValue') {
      setFractionDisabled(false);
      setIntervalDisabled(false);
      setAgeDisabled(true);
    }
    setFractionValue(0);
    setIntervalValue(0);
    setAgeValue(0);
  };
  const changefraction = (e) => {
    setFractionValue(e.target.value);
  };
  const changeinterval = (e) => {
    setIntervalValue(e.target.value);
  };
  const changeage = (e) => {
    setAgeValue(e.target.value);
  };
  const handleCalculate = () => {
    if (value === 'fractionValue') {
      setFractionValue(((1.0 / (2.0 * ageValue / intervalValue - 1.0)) * 100).toFixed(2));
    } else if (value === 'intervalValue') {
      setIntervalValue((2.0 * ageValue / (1.0 + 1.0 / (fractionValue * 0.01))).toFixed(2));
    } else if (value === 'ageValue') {
      setAgeValue((0.5 * intervalValue * (1.0 / (fractionValue * 0.01) + 1.0)).toFixed(2));
    }
  };
  useEffect(() => {
  }, []);

  return (
    <Draggable handle='.rodg-box'
      cancel='.rodg-header-text, .content-tab-title, .rodg-content-grid, .MuiButton-contained, .cancel-handle'
      onStart={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}>
      <Modal
        hideBackdrop
        open={visibleEAC}
        onClose={handleCloseEAC}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        className="rodg-modal"
      >
        <Box className='rodg-box' style={{ width: '40%' }}>
          <Grid container className='rodg-grid-container'>
            <Grid item xs={12}>
              <Grid item xs={12} className='rodg-header-grid_CAL'>
                <div className='rodg-header-text rufusBld'>{translateObject('Element Age Calculator')}</div>
                <div className='rodg-close-icon'>
                  <Tooltip title="Close">
                    <img
                      src={closeIconBlack}
                      alt="close"
                      onClick={handleCloseEAC}
                      style={{ width: '14px', padding: '11px' }}
                      className="pointer"
                    />
                  </Tooltip>
                </div>
              </Grid>
              <Grid id='rodgCont'>
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={value}
                    onChange={handleChange}
                  >
                    <Grid item xs={12} className='input_dosing_select'>
                      <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                        <Grid item xs={0.7}>
                          <FormControlLabel value='fractionValue' control={<Radio />} />
                        </Grid>
                        <Grid item xs={11} className={fractionDisabled ? 'input_group_calculator cal_disbled' : 'input_group_calculator'}>
                          <Grid item xs={8} className='label_cal'>{translateObject('Element Replacement Percentage')}</Grid>
                          <Grid item xs={3}>
                            <input type='number' id='metcon' value={fractionValue} onChange={(e) => { changefraction(e); }}
                              onFocus={e => e.target.select()}
                              disabled={fractionDisabled} className='cancel-handle Form_Input_design_cal ' required />
                          </Grid>
                          <Grid item xs={1}>
                            <div className='no_drag Form_Input_design_Units'>%</div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} className='input_dosing_select'>
                      <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                        <Grid item xs={0.7}>
                          <FormControlLabel value='intervalValue' control={<Radio />} />
                        </Grid>
                        <Grid item xs={11} className={intervalDisabled ? 'input_group_calculator cal_disbled' : 'input_group_calculator'}>
                          <Grid item xs={8} className='label_cal'>{translateObject('Element Replacement Interval')}</Grid>
                          <Grid item xs={2.5}>
                            <input type='number' id='metcon' value={intervalValue} onChange={(e) => { changeinterval(e); }}
                              onFocus={e => e.target.select()}
                              disabled={intervalDisabled} className='cancel-handle Form_Input_design_cal ' required />
                          </Grid>
                          <Grid item xs={1.5}>
                            <div className='no_drag Form_Input_design_Units'>Year(s)</div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} className='input_dosing_select'>
                      <Grid container className='dosing-textbox' style={{ display: 'flex', alignItems: 'center' }}>
                        <Grid item xs={0.7}>
                          <FormControlLabel value='ageValue' control={<Radio />} />
                        </Grid>
                        <Grid item xs={11} className={ageDisabled ? 'input_group_calculator cal_disbled' : 'input_group_calculator'}>
                          <Grid item xs={8} className='label_cal'>{translateObject('Element Average Age')}</Grid>
                          <Grid item xs={2.5}>
                            <input type='number' id='metcon' value={ageValue} onChange={(e) => { changeage(e); }}
                              onFocus={e => e.target.select()}
                              disabled={ageDisabled} className='cancel-handle Form_Input_design_cal ' required />
                          </Grid>
                          <Grid item xs={1.5}>
                            <div className='no_drag Form_Input_design_Units'>Year(s)</div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </RadioGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} className='rodg-footer-grid float-r'>
                <Button
                  id='rodgOkBtn'
                  size="small"
                  variant="contained"
                  className="sansW4SeLig M_Bold rodgCancleBtn"
                  onClick={handleCloseEAC}
                  style={{ width: '110px', fontSize: '16px' }}>
                  {translateObject('Cancel')}
                </Button>
                <Button
                  id='rodgOkBtn'
                  size="small"
                  variant="contained"
                  className="sansW4SeLig M_Bold rodgOkBtn"
                  onClick={handleCalculate}
                  startIcon={<img src={calculator_icon} alt="cal" style={{ width: '14px', padding: '11px' }} />}
                  style={{ width: '130px', fontSize: '16px', marginLeft: '12px' }}> {translateObject('Calculate')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Draggable>
  );
}

export default ElementAgeCalculator;
